import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import NavBar from './Application/components/NavBar';
import GoBackUp from './Application/components/GoBackUp';
import Footer from './Application/components/Footer';

import Accueil from './Application/pages/Accueil';
import Catalogue from './Application/pages/Catalogue';
import Evenement from './Application/pages/Evenement';
import DynamicConcertGallery from './Application/components/DynamicEvenementGallery';
import DynamicShootingGallery from './Application/components/DynamicShootingGallery';
import DynamicDroneGallery from './Application/components/DynamicDroneGallery';
import DynamicArgentiqueGallery from './Application/components/DynamicArgentiqueGallery';
import DynamicNatureGallery from './Application/components/DynamicNatureGallery';
import DynamicManifGallery from './Application/components/DynamicManifGallery';
import Prestations from './Application/pages/Prestations';
import Apropos from './Application/pages/Apropos';
import Contact from './Application/pages/Contact';
import Mentions from './Application/pages/Mentions';
import NotFound from './Application/components/NotFound';

function App() {
  const location = useLocation();
  const originalColorRef = useRef<string>('');
  const isInitializedRef = useRef<boolean>(false);
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  // Scroll to top à chaque changement de route
  useEffect(() => {
    const topElement = document.getElementById('top');
    if (topElement) {
      topElement.scrollIntoView({ behavior: 'auto', block: 'start' });
    } else {
      // Fallback si l'élément n'est pas trouvé
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location.pathname]);

  // Gestion du scroll pour la page d'accueil
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Vous pouvez ajuster cette valeur (100) selon vos besoins
      const scrollThreshold = 100;
      setIsScrolled(scrollPosition > scrollThreshold);
    };

    // Ajouter l'écouteur d'événement seulement si on est sur la page d'accueil
    if (location.pathname === '/') {
      window.addEventListener('scroll', handleScroll);
      // Vérifier la position initiale
      handleScroll();
    } else {
      // Reset sur les autres pages
      setIsScrolled(false);
    }

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);

  useEffect(() => {
    // Sauvegarder la valeur originale une seule fois
    if (!isInitializedRef.current) {
      const rootElement = document.documentElement;
      const computedStyle = getComputedStyle(rootElement);
      originalColorRef.current = computedStyle.getPropertyValue('--phone-menu-bar-color').trim();
      isInitializedRef.current = true;
    }

    // Vérifier si nous sommes sur une route qui nécessite une navbar opaque
    const isOpaqueRoute = location.pathname.includes('/evenement') || 
                         location.pathname.includes('/catalogue') ||
                         location.pathname.includes('/shooting') || 
                         location.pathname.includes('/drone') ||
                         location.pathname.includes('/nature') ||
                         location.pathname.includes('/argentique') ||
                         location.pathname.includes('/manifestation') ||
                         location.pathname.includes('/contact') ||
                         location.pathname.includes('/prestations') ||
                         location.pathname.includes('/mentions-legales') ||
                         location.pathname.includes('/apropos');

    const isHomePage = location.pathname === '/';
    const rootElement = document.documentElement;

    if (isOpaqueRoute || (isHomePage && isScrolled)) {
      // Appliquer la couleur opaque pour les autres pages ou la page d'accueil après scroll
      rootElement.style.setProperty('--phone-menu-bar-color', 'rgba(220, 216, 200, 0.4)');
    } else {
      // Restaurer la couleur originale (transparente) pour la page d'accueil
      if (originalColorRef.current) {
        rootElement.style.setProperty('--phone-menu-bar-color', originalColorRef.current);
      } else {
        rootElement.style.removeProperty('--phone-menu-bar-color');
      }
    }
  }, [location.pathname, isScrolled]);

  return (
    <div className="App" id="top">
      <div id='site'>
        <NavBar />
        <Routes>
          <Route path="/" element={<Accueil />} />

          {/* Page catalogue globale */}
          <Route path="/catalogue" element={<Catalogue />} />

          {/* Sous-catégories de catalogue */}
          <Route path="/catalogue/evenement" element={<Evenement />} />
          <Route path="/catalogue/evenement/:concertName" element={<DynamicConcertGallery />} />
          <Route path="/catalogue/shooting" element={<DynamicShootingGallery />} />
          <Route path="/catalogue/drone" element={<DynamicDroneGallery />} />
          <Route path="/catalogue/argentique" element={<DynamicArgentiqueGallery />} />
          <Route path="/catalogue/nature" element={<DynamicNatureGallery />} />
          <Route path="/catalogue/manifestation" element={<DynamicManifGallery />} />

          <Route path="/prestations" element={<Prestations />} />
          <Route path="/apropos" element={<Apropos />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<Mentions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
      </div>
      <GoBackUp />
    </div>
  );
}

export default App;